import { useEffect, useState } from 'react';

export function useMarketClock() {
  const [state, setState] = useState<{ open: boolean; label: string; window: string }>(
    { open: false, label: 'CLOSED', window: 'Opens in —' }
  );

  useEffect(() => {
    const tz = 'Africa/Dar_es_Salaam';
    const mkDate = (y:number,m:number,d:number, hh:number, mm:number) =>
      new Date(`${m+1}/${d}/${y} ${String(hh).padStart(2,'0')}:${String(mm).padStart(2,'0')}:00`);

    const tick = () => {
      const nowLocal = new Date();
      const nowEat = new Date(nowLocal.toLocaleString('en-US', { timeZone: tz }));
      const y = nowEat.getFullYear(), m = nowEat.getMonth(), d = nowEat.getDate();
      const wd = nowEat.getDay();

      let openT  = mkDate(y,m,d, 9,30);
      let closeT = mkDate(y,m,d,16, 0);

      if (wd === 0 || wd === 6) {
        const add = wd === 6 ? 2 : 1;
        const next = new Date(nowEat); next.setDate(d + add);
        const y2=next.getFullYear(), m2=next.getMonth(), d2=next.getDate();
        openT  = mkDate(y2,m2,d2, 9,30);
        closeT = mkDate(y2,m2,d2,16, 0);
      }

      const openNow  = nowEat >= openT && nowEat < closeT && wd >= 1 && wd <= 5;
      const target   = openNow ? closeT : openT;
      let ms = target.getTime() - nowEat.getTime();
      if (!openNow && ms < 0) {
        const next = new Date(openT); next.setDate(openT.getDate() + (wd >= 5 ? (8-wd) : 1));
        ms = next.getTime() - nowEat.getTime();
      }
      const h = Math.max(0, Math.floor(ms / 3_600_000));
      const mns = Math.max(0, Math.floor((ms % 3_600_000) / 60_000));
      const s = Math.max(0, Math.floor((ms % 60_000) / 1000));
      const countdown = `${h}h ${mns}m ${s}s`;

      setState({
        open: openNow,
        label: openNow ? 'OPEN' : 'CLOSED',
        window: (openNow ? 'Closes in: ' : 'Opens in: ') + countdown
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  return state;
}
